var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.50781H15V3.50781H9V1.50781ZM11 14.5078V8.50781H13V14.5078H11ZM19.03 7.88781L20.45 6.46781C20.02 5.95781 19.55 5.47781 19.04 5.05781L17.62 6.47781C16.07 5.23781 14.12 4.49781 12 4.49781C7.03 4.49781 3 8.52781 3 13.4978C3 18.4678 7.02 22.4978 12 22.4978C16.98 22.4978 21 18.4678 21 13.4978C21 11.3878 20.26 9.43781 19.03 7.88781ZM5 13.5078C5 17.3778 8.13 20.5078 12 20.5078C15.87 20.5078 19 17.3778 19 13.5078C19 9.63781 15.87 6.50781 12 6.50781C8.13 6.50781 5 9.63781 5 13.5078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.0f433063902aeeed35a66b7d8843da5e.svg";
export { ForwardRef as ReactComponent };